import React from "react";
import CustomNav from "../Components/NavBar";
import { Container, Badge } from "react-bootstrap";
import { projectsList } from "../utils/helperList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkAlt, faCode, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";

const Projects = () => {
  return (
    <>
      <CustomNav />
      <Container className="projects-page mt-5 mb-5" as="section">
        {/* <h1 className="projects-heading color-customBlue mb-4">Projects</h1> */}

        <div className="projects-list">
          {projectsList.map((proj) => (
            <article key={proj.label} className="project-card">
              <header className="project-card__header">
                <h2 className="project-card__title color-customBlue">
                  {proj.label}
                </h2>
                {proj.client && (
                  <a
                    href={proj.client.aboutUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="project-card__client"
                    aria-label={`About ${proj.client.name}`}
                  >
                    <FontAwesomeIcon icon={faMapMarkerAlt} className="mr-1" />
                    {proj.client.location}
                  </a>
                )}
              </header>

              {proj.description && (
                <p className="project-card__description color-customBlueLight">
                  {proj.description}
                </p>
              )}

              {proj.features?.length > 0 && (
                <ul className="project-card__features">
                  {proj.features.map((feature, i) => (
                    <li key={i}>{feature}</li>
                  ))}
                </ul>
              )}

              <div className="project-card__stack">
                {proj.stack?.map((tech) => (
                  <Badge key={tech} pill className="project-card__badge">
                    {tech}
                  </Badge>
                ))}
              </div>

              <div className="project-card__links">
                {proj.src && proj.src !== "#" && (
                  <a
                    href={proj.src}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="project-card__link"
                    aria-label={`Open ${proj.label} live`}
                  >
                    <FontAwesomeIcon icon={faExternalLinkAlt} className="mr-1" />
                    Live project
                  </a>
                )}
                {proj.githubSrc && (
                  <a
                    href={proj.githubSrc}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="project-card__link"
                    aria-label={`View source code for ${proj.label}`}
                  >
                    <FontAwesomeIcon icon={faCode} className="mr-1" />
                    Source code
                  </a>
                )}
              </div>
            </article>
          ))}
        </div>
      </Container>
    </>
  );
};

export default Projects;
